export default "__VITE_ASSET__5324397e__"